export default __webpack_public_path__ + "musical-bell-outline.png";